<template>
  <div class="hidden sm:block">
    <div class="relative">
      <input
        type="text"
        class="w-64 border rounded-full p-2 px-4"
        placeholder="Procurar..."
        @keydown.enter="search"
        v-model="searchQuery"
      />
      <div
        class="absolute pin-r pin-t p-2 mr-1 text-grey"
        @click="searchQuery = ''"
      >
        <icon
          class="w-4 h-4"
          :class="{ 'text-grey-darkest': searchQuery.length > 0 }"
          name="x"
        ></icon>
      </div>
    </div>
    <portal to="modal">
      <Modal v-if="showSearch" width="lg" :show="showSearch" @close="close">
        <h2 slot="header">Pesquisa Rápida</h2>
        <div slot="body" class="flex flex-wrap">
          <div v-if="!result.products.items.length">
            Nenhum registo encontrado para com o critério de pesquisa:
            <span class="bg-blue-lighter">
              <b
                ><i>{{ searchQuery }}</i></b
              >
            </span>
          </div>
          <div
            class="md:w-1/3 items-center text-center mb-3 px-3"
            v-for="product in result.products.items"
            :key="product.id"
          >
            <img :src="product.image" />
            <div>
              {{ product.name }}
            </div>
            <div>
              <a href="#" @click="goToProduct(product.id)">
                {{ product.model }}
              </a>
            </div>
            <div>{{ formatPrice(product.price) }}</div>
          </div>
        </div>
        <div slot="footer">
          <ButtonBase primary @click="close">Fechar</ButtonBase>
        </div>
      </Modal>
    </portal>
  </div>
</template>

<script>
import Modal from '../modal/Modal.vue';
import { useQuery, useResult } from '@vue/apollo-composable';
import GLOBAL_SEARCH_QUERY from '../../graphql/GlobalSearch.gql';
import { ref, reactive, onMounted, onUnmounted } from '@vue/composition-api';
import gql from 'graphql-tag';
export default {
  components: {
    Modal
  },
  setup(props, ctx) {
    const showSearch = ref(false);
    const searchQuery = ref('');
    const products = ref([]);
    const PRODUCTS_QUERY = gql`
      query getItem($search: String) {
        products(
          pageInfo: { page: 1, pageSize: 9 }
          filters: { search: $search }
        ) {
          items {
            id
            name
            image
            price
            model
          }
        }
      }
    `;

    const formatPrice = price => {
      if (!price) return;
      return price.toFixed(2).replace('.', ',') + ' €';
    };

    const { result, loading, error, refetch } = useQuery(PRODUCTS_QUERY, {
      search: searchQuery
    });

    const search = () => {
      showSearch.value = true;
      refetch();
    };

    const close = () => {
      showSearch.value = false;
    };
    const handleEscPress = e => {
      if (e.key === 'Escape') {
        showSearch.value = false;
      }
      return;
    };
    onMounted(() => {
      window.addEventListener('keydown', handleEscPress);
    });
    onUnmounted(() => {
      window.removeEventListener('keydown', handleEscPress);
    });
    const goToProduct = productId => {
      ctx.root.$router.push('/products/' + productId);
      close();
    };

    return {
      search,
      searchQuery,
      showSearch,
      result,
      refetch,
      close,
      formatPrice,
      goToProduct
    };
  }
};
</script>

<style>
.custom-width {
  width: 30rem;
}
</style>



// WEBPACK FOOTER //
// GlobalSearch.vue?47e2028c